import { usersId, type UsersId } from "./Users";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for two_factors */
export type TwoFactorsId = string & { __flavor: "TwoFactorsId" };

/**
 * Represents the table public.two_factors
 * @uniqueConstraints {"two_factors_pkey":{"name":"two_factors_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"two_factor_secret_index":{"name":"two_factor_secret_index","isPrimary":false,"isUnique":false,"columns":[{"name":"secret","definition":"secret","predicate":null}]}}
 */
export default interface TwoFactorsTable {
  id: ColumnType<TwoFactorsId, TwoFactorsId, TwoFactorsId>;

  secret: ColumnType<string, string, string>;

  backupCodes: ColumnType<string, string, string>;

  userId: ColumnType<UsersId, UsersId, UsersId>;
}

export type TwoFactors = Selectable<TwoFactorsTable>;

export type NewTwoFactors = Insertable<TwoFactorsTable>;

export type TwoFactorsUpdate = Updateable<TwoFactorsTable>;

export const twoFactorsId = z.string() as unknown as z.Schema<TwoFactorsId>;

export const twoFactors = z.object({
  id: twoFactorsId,
  secret: z.string(),
  backupCodes: z.string(),
  userId: usersId,
});

export const twoFactorsInitializer = z.object({
  id: twoFactorsId,
  secret: z.string(),
  backupCodes: z.string(),
  userId: usersId,
});

export const twoFactorsMutator = z.object({
  id: twoFactorsId.optional(),
  secret: z.string().optional(),
  backupCodes: z.string().optional(),
  userId: usersId.optional(),
});

// ── constraints for TwoFactors ─────────────────────────────────
export const TwoFactorsConstraints = {
  two_factors_pkey: {
    name: "two_factors_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  two_factor_secret_index: {
    name: "two_factor_secret_index",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "secret", definition: "secret", predicate: null }],
  },
} as const;
export type TwoFactorsConstraintsType = typeof TwoFactorsConstraints;
